import * as amplitude from "@amplitude/analytics-react-native"
import { useNavigation } from "@react-navigation/native"
import { LinearGradient } from "expo-linear-gradient"
import React, { useContext, useEffect, useMemo, useRef } from "react"
import { Image, Linking, ScrollView, View } from "react-native"
import { connect } from "react-redux"
import promotion from "../../../assets/diagnostic/cta/balise-de-remise.png"
import logo from "../../../assets/logo-blue.png"
import FilledButtonM from "../../common/components/button/FilledButtonM"
import {
    DiagnosticNavigationM,
    SwipeableWrapper,
} from "../../common/components/navigation/DiagnosticNavigationM"
import TextM from "../../common/components/text/TextM"
import { theme } from "../../common/theme/theme"
import {
    DimensionsContext,
    IS_WEB,
    isWebMobile,
} from "../../common/utils/mobileUtils"
import { apiIdle, apiRequest } from "../../data/redux/actions/api"
import {
    getCTAData,
    getDiagnosticData,
    getMockDiagnosticData,
} from "../diagnostic/DiagnosticHelpers"

function CTAScreen(props) {
    const navigation = useNavigation()
    const dimensions = useContext(DimensionsContext)
    const page = 7
    const scrollViewRef = useRef(null)

    const data = useMemo(() => {
        return Object.keys(props.analysisData).length
            ? getDiagnosticData(props.analysisData)
            : getMockDiagnosticData()
    }, [props.analysisData])

    const { prioritySubject, studentAverage, objectifTarget } = getCTAData(
        props.analysisData
    )

    const width =
        dimensions.width > 800 ? dimensions.width / 2.2 : dimensions.width - 20

    const goToPrevPage = () => {
        if (page > 1) {
            navigation.navigate("school-card-report/diagnostic", {
                pageNumber: page - 1,
            })
        }
    }

    const openExternalLink = async () => {
        const url = "https://masteur.com/home?ref=GMXd9pobxW"

        if (IS_WEB) {
            window.location.href = url
        } else {
            const canOpen = await Linking.canOpenURL(url)
            if (canOpen) {
                await Linking.openURL(url)
            } else {
                console.error("Cannot open URL: " + url)
            }
        }
    }

    useEffect(() => {
        if (scrollViewRef.current) {
            scrollViewRef.current.scrollTo({ x: 0, y: 0, animated: true })
        }
    }, [page])

    useEffect(() => {
        amplitude.track(`school_card_report.diagnostic_screen_cta`)
    }, [])

    return (
        <SwipeableWrapper
            onSwipeLeft={() => {}}
            onSwipeRight={() => {
                amplitude.track(
                    "school_card_report.diagnostic_screen_cta.swipe_right"
                )
                goToPrevPage()
            }}
            colors={["#FFFFFF", "#2196F3"]}
            style={{ flex: 1, ...(isWebMobile() && { minHeight: "100dvh" }) }}
        >
            <ScrollView
                ref={scrollViewRef}
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
                style={{ flex: 1, width: "100%" }}
                contentContainerStyle={{
                    flexGrow: 1,
                    alignItems: "center",
                }}
            >
                <LinearGradient
                    colors={["#FFFFFF", "#2196F3"]}
                    style={{
                        flex: 1,
                        paddingTop: 20,
                        width: "100%",
                        height: "100%",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <View
                        style={{
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <View
                            style={{
                                marginVertical: 16,
                                alignItems: "center",
                            }}
                        >
                            <Image
                                source={logo}
                                style={{
                                    width: 200,
                                    height: 60,
                                    resizeMode: "contain",
                                }}
                            />
                        </View>

                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                width,
                            }}
                        >
                            <TextM
                                fontSize={32}
                                fontWeight="ExtraBold"
                                color={theme.colors.primary}
                                style={{
                                    textAlign: "center",
                                    flex: 1,
                                }}
                                wrap={true}
                            >
                                On peut vous aider !
                            </TextM>
                        </View>

                        <Image
                            source={promotion}
                            style={{
                                width: (width * 2) / 5 + 20,
                                height: (width * 2) / 5 + 20,
                                resizeMode: "contain",
                                marginVertical: 20,
                                shadowColor: "#000",
                                shadowOffset: { width: 0, height: 4 },
                                shadowOpacity: 0.2,
                                shadowRadius: 4,
                                elevation: 8,
                            }}
                        />
                    </View>

                    <View style={{ flex: 1 }} />

                    <View
                        style={{
                            width: "100%",
                            paddingHorizontal: 20,
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: 20,
                        }}
                    >
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                maxWidth: width,
                            }}
                        >
                            <TextM
                                fontSize={28}
                                fontWeight="ExtraBold"
                                color="white"
                                style={{
                                    textAlign: "center",
                                }}
                                wrap={true}
                            >
                                3 mois pour passer de {""}
                                <TextM
                                    fontSize={42}
                                    fontWeight="Bold"
                                    color="#FFD54F"
                                    style={{ textAlign: "center" }}
                                >
                                    {studentAverage}
                                </TextM>
                                {" à "}
                                <TextM
                                    fontSize={42}
                                    fontWeight="ExtraBold"
                                    color="#FFD54F"
                                    style={{ textAlign: "center" }}
                                >
                                    {objectifTarget}
                                </TextM>
                                {` en ${prioritySubject} avec nos cours de soutien`}
                            </TextM>
                        </View>
                    </View>

                    <View
                        style={{
                            width: "100%",
                            paddingHorizontal: 20,
                            gap: 20,
                            marginBottom: 20,
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <FilledButtonM
                            style={{
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#FFD54F",
                            }}
                            onPress={() => {
                                amplitude.track(
                                    "school_card_report.diagnostic_screen_cta.press_cta"
                                )
                                openExternalLink()
                            }}
                            label="Profiter de l'offre"
                        />
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: 4,
                            }}
                        >
                            <DiagnosticNavigationM
                                style={{
                                    width,
                                    position: "absolute",
                                    alignSelf: "center",
                                }}
                                currentIndex={Number(page) - 1}
                                url="/school-card-report/diagnostic"
                                data={data}
                                onPressLeft={() => {
                                    amplitude.track(
                                        "school_card_report.diagnostic_screen_cta.press_right"
                                    )
                                    goToPrevPage()
                                }}
                                onPressRight={() => {}}
                            />

                            {Array.from({
                                length: data.length + 1,
                            }).map((_, index) => (
                                <View
                                    key={index}
                                    style={{
                                        width: index === page - 1 ? 20 : 10,
                                        height: 10,
                                        borderRadius: 5,
                                        marginHorizontal: 5,
                                        backgroundColor: theme.colors.primary,
                                        opacity: index === page - 1 ? 1 : 0.5,
                                        transition: "width 0.3s ease",
                                    }}
                                />
                            ))}
                        </View>
                    </View>
                </LinearGradient>
            </ScrollView>
        </SwipeableWrapper>
    )
}

const mapStateToProps = (state) => ({
    analysisData: state.data.schoolCardReport?.analysisData || {},
})

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(CTAScreen)
